import Spinner from "react-bootstrap/Spinner";
export default function PageLoading() {
    return (
        <div className="text-center py-5 my-5">
            <Spinner variant="primary" />
        </div>
    );
}
